import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://169.58.21.41/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export const generateReport = async (fieldId, userId, language = 'tr') => {
    try {
        const response = await api.post('/reports/generate', {
            fieldId,
            userId,
            language
        });

        return response.data;
    } catch (error) {
        console.error('Error generating report:', error);
        throw error;
    }
};

export default {
    generateReport
};
